@if (visible) {
<div class="page-overlay" [class.page-overlay--closing]="isClosing">
  <img class="page-overlay__logo" src="assets/icon/favicon-9.png" alt="" />
  @if (showProgress) {
    <div class="page-overlay__bar" role="progressbar" [attr.aria-label]="'callback.completing' | translate">
      <div class="page-overlay__bar-fill"></div>
    </div>
  }
</div>
}
